// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : Added Comment Lines, Response and List Name Changes.
// Modified Date: 18-08-2025

/* eslint-disable import/no-anonymous-default-export */
import CloseLoanActionTypes from './close-loan.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Close Loan Member List Response
	getCloseLoanMemberListResponse: null,
	// Close Loan Member List Array
	getCloseLoanMemberListArr: [],
	// Update Close Loan Member List Response
	updateCloseLoanMemberListResponse: null,
	// Update Close Loan Member List Array
	updateCloseLoanMemberListArr: [],
	// Revert Close Loan Member List Response
	revertCloseLoanMemberListResponse: null,
	// Update Close Loan Member List Array
	revertCloseLoanMemberListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET CLOSE LOAN LIST START *********************** */
		case CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				getCloseLoanMemberListResponse: action.payload,
				// Get Close Loan Member List Array
				getCloseLoanMemberListArr: docodeHexResponse(
					action.payload,
					'GetGroupMemberDetailsForCloseDetailsKey',
				),
			};

		case CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, getCloseLoanMemberListResponse: action.payload };

		case CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, getCloseLoanMemberListResponse: null };

		/** ***************** GET CLOSE LOAN LIST START *********************** */

		/** ***************** UPDATE CLOSE LOAN START *********************** */
		case CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				updateCloseLoanMemberListResponse: action.payload,
				// Update Close Loan Member List Array
				updateCloseLoanMemberListArr: docodeHexResponse(
					action.payload,
					'UpdateGroupMemberDetailsForCloseKey',
				),
			};

		case CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, updateCloseLoanMemberListResponse: action.payload };

		case CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_RESPONSE_CHANGED:
			return {
				...state,
				updateCloseLoanMemberListResponse: null,
				updateCloseLoanMemberListArr: [],
			};

		/** ***************** UPDATE CLOSE LOAN START *********************** */

		/** ***************** REVERT CLOSE LOAN START *********************** */
		case CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				revertCloseLoanMemberListResponse: action.payload,
				// Revert Close Loan Member List Array
				revertCloseLoanMemberListArr: docodeHexResponse(
					action.payload,
					'RevertGroupMemberDetailsForCloseKey',
				),
			};

		case CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, revertCloseLoanMemberListResponse: action.payload };

		case CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_RESPONSE_CHANGED:
			return {
				...state,
				revertCloseLoanMemberListResponse: null,
				revertCloseLoanMemberListArr: [],
			};
		/** ***************** REVERT CLOSE LOAN START *********************** */
		default:
			return state;
	}
};
